module.exports = __webpack_public_path__ + "static/20200620-科创百强-ecaa9240dcb30cfb0ba1704315d24578.png";